import { FC, useEffect, useState } from "react"
import { LoadingStatus } from "../../../@types/enumsGlobal"
import { PluginWrapper } from "../../../components/plugins"
import { LabelPrintingDataProvider } from "../../../Services/DataProviders/LabelPrintingDataProvider"
import useGridFilter from "../../../system/hooks/useGridFilter"
import { useAppContext } from "../../../system/providers/appContextProvider"
import { ILabelPrintLot } from "../Shared/Interfaces/ILabelPrintLot"
import { ChangeableGrid, IChangeDataGrid } from "../../../components/grids/changeableGrid/ChangeableGrid"
import { ISelectingPrintItems, IViewLabelsFilter } from "./LotSelectorPluginViewNew"

export const LotSelectorPluginView: FC<ISelectingPrintItems> = (props) => {
    const appCtx = useAppContext();
    const dataProvider = new LabelPrintingDataProvider(appCtx.reportAPIService);

    const [data, setData] = useState<ILabelPrintLot[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>([]);
    const [viewState, setViewState] = useState<GridStateType>("refresh");
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess)

    useEffect(() => {
        if (viewState === 'refresh') {
            setViewState('view')
            const payload = { Item1: { ids: props.documentsIds, filter: gridFilter }, Item2: props.materGridFilter } as IViewLabelsFilter
            dataProvider.getViewByParams(props.idTable, payload, props.isKiz, (e: Array<ILabelPrintLot>, c: Array<IGridColumn>) => {
                if (props.plugin.columns.length == 0)
                    props.plugin.columns.push(...c)
                const totalCount = e.length
                if (totalCount > 0) {
                    setLoadingStatus(LoadingStatus.Completed)
                } else {
                    setLoadingStatus(LoadingStatus.NoData)
                }
                setData(e)
                setTotalCount(totalCount)
            }
                , () => {
                    setLoadingStatus(LoadingStatus.Failed)
                })
       }
    }, [viewState,gridFilter])

    const changeData = (changes: IChangeDataGrid[]) => {
        const quantityChanges = changes.filter(change =>
            ['labelQuantity', 'priceQuantity', 'stelQuantity'].includes(change.propertyName))
        if (quantityChanges.length === 0) return

        setData(previousData => previousData.map(item => {
            const rowChanges = quantityChanges.filter(change => change.idGlobal === item.idGlobal)
            return rowChanges.reduce((updatedItem, change) => (
                { ...updatedItem, [change.propertyName]: change.value as number }
            ), item)
        }))

        const nextSelectedItems = selectedItems.map(row => ({
            ...row,
            cells: row.cells.map(cell => {
                const change = quantityChanges.find(change =>
                    change.idGlobal === row.idGlobal && change.propertyName === cell.propertyName)
                return change ? { ...cell, value: change.value } : cell
            })
        }))
        setSelectedItems(nextSelectedItems)
        props.onMultipleSelectRows?.(nextSelectedItems)
    }

    return (
        <PluginWrapper>
            <ChangeableGrid
                gridId={props.gridId}
                data={data}
                documentStateProc={false} 
                totalCount={totalCount}
                filter={gridFilter}
                dataProvider={dataProvider}
                plugin={props.plugin}
                selectedItem={selectedItem}
                selectedItems={selectedItems}
                multipleSelect={true}
                onDoubleClick={(row) => props.onDoubleClick?.(row)}
                onMultipleSelect={(rows) => {
                    setSelectedItems(rows)
                    props.onMultipleSelectRows?.(rows)
                }}
                onSelect={(row) => {
                    setSelectedItem(row)
                }}
                onChangeData={(e) => changeData([e])}
                groupEditing={{ enabled: false }}
                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                onFilterDelete={(i) => { }}
                onPageNumberChange={(n) => { }}
                onNumberPerPageChange={(n) => { }}
                onEnter={() => setViewState("edit")}
            />
        </PluginWrapper>
    )
}
